
// src/pages/VerifySuccess.jsx
import React, { useEffect, useState } from "react";
import { Container, Alert, Button } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { auth } from "../firebase";

export default function VerifySuccess() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const communityId = params.get("community") || "";
  const [reloaded, setReloaded] = useState(false);

  useEffect(() => {
    (async () => {
      if (auth.currentUser) {
        try {
          await auth.currentUser.reload();
          setReloaded(true);
        } catch {
          setReloaded(true);
        }
      } else {
        setReloaded(true);
      }
    })();
  }, []);

  const goNext = () => {
    if (communityId) navigate(`/resident/${communityId}`);
    else navigate("/");
  };

  return (
    <Container className="py-4">
      <Alert variant="success" className="mb-3">
        <h4 className="mb-2">Email verified!</h4>
        <p>Your email address has been successfully verified.</p>
        {reloaded && auth.currentUser?.emailVerified ? (
          <p className="mb-0">You can now access all features.</p>
        ) : (
          <p className="mb-0">You can now return to your account.</p>
        )}
      </Alert>
      <Button onClick={goNext}>
        {communityId ? "Go to your community" : "Go to home"}
      </Button>
    </Container>
  );
}
